import { Expose } from "class-transformer";
import { observable } from "mobx";
import ReqLinksInSectionSection from "../entities/reqLinksInSectionSection";

export default class LinksFilter {
  @observable
  @Expose({ name: "filters[section]" })
  section?: ReqLinksInSectionSection;
}
